<template>
  <v-select
    v-model="model"
    :value="role"
    :items="roles"
    label="Роль"
    outlined
    dense
    clearable
    :hide-details="hideDetails"
    :error-messages="errorMessages"
  />
</template>

<script>
import auth from "../../auth";

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    role: {
      type: Object,
      default: () => {},
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
  },
  data() {
    return {
      roles: auth.rolesDict,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(role) {
        this.$emit("input", role);
      },
    },
  },
};
</script>
